<template>
  <!--begin::Loader-->
  <invoice-loader v-if="loader" />
  <!--end::Loader-->
  <b-row
    v-else
    class="match-height"
  >
    <b-col
      cols="12"
      md="8"
    >
      <payments-detail :payment="payment" />
    </b-col>
    <b-col
      cols="12"
      md="4"
    >
      <payments-financial :payment="payment" />
      <user-financial-profile
        v-if="$can('read','payments')"
        :user="payment.user"
      />
    </b-col>
    <b-col cols="12">
      <b-card
        no-body
      >
        <b-card-body>
          <b-tabs>
            <b-tab
              :title="$t('Transactions')"
            >
              <transactions-index />
            </b-tab>
            <b-tab
              :title="$t('Bank receipts')"
            >
              <div
                v-if="$can('create','bank.receipts') || !payment.is_paid"
                class="d-flex justify-content-end mb-1"
              >
                <b-button
                  v-b-modal.modal-bank-receipts-edit
                  size="sm"
                  variant="success"
                >
                  {{ $t('Submit bank receipt') }}
                  <feather-icon icon="PlusIcon" />
                </b-button>
              </div>
              <bank-receipts-index />
            </b-tab></b-tabs>

        </b-card-body>
      </b-card>
    </b-col>
  </b-row>

</template>

<script>
import {
  BRow, BCol, BCard, BCardBody, BTabs, BTab, BCardText, BButton,
} from 'bootstrap-vue'
import PaymentsDetail from '../../components/payments/show/PaymentsDetail'
import PaymentsFinancial from '../../components/payments/show/PaymentsFinancial'
import InvoiceLoader from '../../components/loaders/InvoiceLoader'
import BankReceiptsIndex from '../bank-receipts/Index'
import TransactionsIndex from '../transactions/Index'
import UserFinancialProfile from '../../components/users/show/UserFinancialProfile'

export default {
  name: 'Show',
  components: {
    UserFinancialProfile,
    TransactionsIndex,
    BankReceiptsIndex,
    InvoiceLoader,
    PaymentsFinancial,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTabs,
    BCardText,
    BButton,
    BTab,

    PaymentsDetail,
  },
  props: {
    id: {
      type: [String, Number],
      default: () => 0,
    },
  },
  data() {
    return {
      loader: true,
      payment: {},
      tabs: [],
      hasTransactions: false,
      hasBankReceipts: false,
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loader = true
      this.$http.get(`payments/${this.id}`).then(({ data }) => {
        this.payment = data
        if (
          this.payment.transactions
              && this.payment.transactions.length
        ) {
          this.hasTransactions = true
        }
        if (
          this.payment.bank_receipts.items
              && this.payment.bank_receipts.items.length
        ) {
          this.hasBankReceipts = true
        }
        this.loader = false
      })
    },
  },
}
</script>

<style scoped>

</style>
